import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Ink from 'react-ink'

import TitoloStudio from './titolo_studio'

import { MdAdd } from 'react-icons/md'

class TitoliStudio extends Component {
  renderTitoliStudio() {
    if (this.props.titoliStudio) {
      return this.props.titoliStudio.map((titoloStudio) => {
        return (
          <TitoloStudio
            key={titoloStudio.titoloStudioId}
            titoloStudio={titoloStudio}
            candidatoId={this.props.candidatoId}
            canEdit={this.props.canEdit}
          />
        )
      })
    }
    return <span>Caricamento in corso...</span>
  }

  render() {
    return (
      <div className="card-box">
        <h4 className="header-title">Titoli di studio</h4>
        {this.renderTitoliStudio()}

        {this.props.canEdit ? (
          <div className="text-right">
            <Link
              to={`/app/candidati/${this.props.candidatoId}/titoli-studio/new`}
              className="btn btn-sm btn-blue"
            >
              <Ink />
              <MdAdd />
              Aggiungi titolo
            </Link>
          </div>
        ) : null}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    candidatoId: state.candidatoAttivo.candidatoId,
    titoliStudio: state.candidatoAttivo.titoliStudio,
    canEdit:
      !!state.auth.user.permessi['titoliStudio'] &&
      state.candidatoAttivo.sportello &&
      state.candidatoAttivo.sportello.sportelloId === state.auth.user.sportelloCorrente.sportelloId,
  }
}

export default connect(mapStateToProps)(TitoliStudio)
